import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=e6225d0c&scoped=true&lang=pug&"
import script from "./FileDropzone.vue?vue&type=script&lang=js&"
export * from "./FileDropzone.vue?vue&type=script&lang=js&"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=e6225d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6225d0c",
  null
  
)

export default component.exports